module.exports = __webpack_public_path__ + "img/pyramid_blue_lg.ea5a6e8d.png";